import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import SuppliersCar from "../components/suppliers-car";

const ApiTransferIntegration = () => {
  return (
    <div>
      <PageHeader page="transfer-api-integration" />
      <div className="container">
        <div className="text-center">
          <p>
            85+ suppliers integrated—we manage integration complexity for you. Enterprise integration options: managed service (we handle it), custom connectors (built to your spec), or API-first architecture (extend without replacement). Deep relationships with ground operators, car rental, and transfers providers mean ongoing support, not just one-time integration.
          </p>

          <SuppliersCar />
        </div>
      </div>
    </div>
  );
};

export default ApiTransferIntegration;
